export default __webpack_public_path__ + "static/media/position-switcher-right.ff28ab46.svg";